import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { Action } from "../../types/toolbar";
import CustomModal from "../../components/ui/modal/modal.component";
import EquipmentAttributeForm from "../../components/ui/equipmentAttributeForm/equipmentAttributeForm.component";
import { useHasPermission } from "../../contexts/auth";

export const ConfigurationsListActions = () => {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);
  const canAdd = useHasPermission("settlement.add_equipmentattribute");

  const actions: Action[] = [
    {
      id: "add-configuration",
      icon: <AddIcon />,
      label: t("Add configuration"),
      onClick: () => setOpened(true),
      disabled: !canAdd,
    },
  ];

  const handleSuccess = () => {
    setOpened(false);
    window.dispatchEvent(new Event("equipmentAttributeAdded"));
  };

  return (
    <>
      <Toolbar actions={actions} />
      <CustomModal
        opened={opened}
        setOpened={setOpened}
        title={t("Add configuration")}
        content={<EquipmentAttributeForm onSuccess={handleSuccess} />}
      />
    </>
  );
};
